import React from 'react'
import Styles from '../styles/App.scss'
import Tweet from './Tweet'

class TweetArray extends React.Component{

  render() {   

  	return(
		  <div className='tweetArrayContainer' >
			  <div className='tweetArray' >
			  	<div className='tweetArray-col tweetArray-col--1' >
				    
			  		<Tweet
				    	tweetId='1035528699989434370'
				    	userName='Kelly Looman'
				    	handle='MrsLooman'
				    	timestamp='31 Aug'		    	
				    />

				    <Tweet
				    	tweetId='1035549143794700291'
				    	userName="Ms. Chan's Class"
				    	handle='MissChansClass'
				    	timestamp='31 Aug'
				    	image
				    />		    

				    <Tweet
				    	tweetId='1034104675828682752'
				    	userName='Kristen Kiss'
				    	handle='kkkissteaches'
				    	timestamp='27 Aug'		    	
				    />

				    <Tweet
				    	tweetId='1031705048714301442'
				    	userName='Melissa Summerford'
				    	handle='Mekayjs'
				    	timestamp='21 Aug'		    	
				    />
			    </div>
			    <div className='tweetArray-col tweetArray-col--2' >
				    <Tweet
				    	tweetId='1035621109469728774'
				    	userName='Clare Matusevich'
				    	handle='C_Matusevich'
				    	timestamp='31 Aug'
				    />		    
				    <Tweet
				    	tweetId='961065696594546688'
				    	userName='Ms. Visconti'
				    	handle='MsVLosOsos'		    	
				    	timestamp='7 Feb'
				    	video
				    />
				    <Tweet
				    	tweetId='1030300303374118913'
				    	userName='Madi Roberts'
				    	handle='MrsRobertsACHS'
				    	timestamp='17 Aug'		    	
				    />

				    

			    </div>
			    <div className='tweetArray-col tweetArray-col--3' >
				    <Tweet
				    	tweetId='1035186446766882816'
				    	userName='Cortnee Hill'
				    	handle='BCES_MsHill'
				    	timestamp='30 Aug'		    	
				    />

				    <Tweet
				    	tweetId='1034510539987345410'
				    	userName='deZavala Library'
				    	handle='DZ_Library'
				    	timestamp='28 Aug'		    	
				    	image
				    />		   
				    
				    <Tweet
				    	tweetId='1033408610196447232'		    	
				    	userName='Melissa Layton'
				    	handle='justmelle76'
				    	timestamp='25 Aug'		    	
				    />

				    

				    <Tweet
				    	tweetId='1033085612172165120'
				    	userName='Miss A'
				    	handle='heidermurph'
				    	timestamp='24 Aug'			    	
				    />

				    

				    {/*
					    <Tweet
					    	tweetId='1029693968504827905'
					    	userName='Ormiston Primary'
					    	handle='OrmistonPrimary'
					    	timestamp='15 Aug'
					    	profilePicURL='https://pbs.twimg.com/profile_images/541118786594553857/el-zQ0Ew_bigger.jpeg'
					    />
				  	*/}	
			    </div>	    
			  </div>
		  </div>
		)
	}
}

export default TweetArray
